import $ from 'jquery'

import Popup from '../../common.blocks/popup'

export default class CallbackPopup extends Popup {
	static title = 'callback-popup'

	constructor($el) {
		super($el)

		this.form = this.$el.findElement('form')
		this.tel = this.form.find('input[name="fields[tel]"]')
		this.agree = this.form.find('input[name="agree"]')
		this.error = this.$el.findElement('error')
		this.submitButton = this.$el.findElement('submit')

		$(document).on('click', `.${CallbackPopup.title}__trigger`, (event) => {
			event.preventDefault()
			this.trigger = event.currentTarget
			this.open()
		})

		this.$el.findElement('done').on('click', () => this.close())
		this.form.on('submit', (event) => {
			event.preventDefault()
			this.submit()
		})

		$(document).on('keydown', (event) => {
			if (this.$el.hasModifier('hidden')) {
				return
			}
			if (event.key === 'Escape') {
				this.close()
			} else if (event.key === 'Tab') {
				this.trapFocus(event)
			}
		})
		$(document).on('overlay:close', () => {
			this.$el.addModifier('hidden')
			this.reset()
		})
	}

	open() {
		this.reset()
		super.open()
		this.tel.trigger('focus')
	}

	close() {
		super.close()
		this.reset()
		this.trigger?.focus()
	}

	reset() {
		this.showStep('form')
		this.setError('')
		this.setLoading(false)
	}

	submit() {
		const tel = (this.tel.val() || '').trim()

		if (tel === '') {
			this.setError('Vul uw telefoonnummer in, zodat wij u kunnen terugbellen.')
			return
		}
		if (!/^\+?[0-9]{8,15}$/.test(tel.replace(/[\s\-().]/g, ''))) {
			this.setError('Vul een geldig telefoonnummer in.')
			return
		}
		if (!this.agree.prop('checked')) {
			this.setError('Ga akkoord met de voorwaarden om verder te gaan.')
			return
		}

		this.setError('')
		this.setLoading(true)

		const formId = this.$el.data('formId')
		const data = new FormData(this.form.get(0))
		data.set('form_id', formId)
		data.set('submit', 1)
		data.set('ajax_form', 1)
		data.set('fields[referer]', window.location.href)

		// /choice also checks the consent server-side
		$.ajax({
			method: 'POST',
			url: '/choice',
			data,
			processData: false,
			contentType: false,
			dataType: 'json',
		})
			.done((json) => {
				if (json.error) {
					this.setError(json.error)
					return
				}

				this.success(tel)
				$(document).trigger('callback:lead', {
					formId,
					source: this.trigger?.dataset.track || 'unknown',
				})
			})
			.fail(() => {
				this.setError(
					'Er ging iets mis bij het versturen. Probeer het opnieuw of bel ons op 0318-241001.',
				)
			})
			.always(() => this.setLoading(false))
	}

	success(tel) {
		this.$el.findElement('tel-confirm').text(tel)
		this.form.trigger('reset')
		this.showStep('success')
		this.$el.findElement('done').trigger('focus')
	}

	trapFocus(event) {
		const focusable = this.$el
			.find('a[href], button, input, [tabindex]:not([tabindex="-1"])')
			.filter(':visible:not(:disabled)')
		const first = focusable.first().get(0)
		const last = focusable.last().get(0)

		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault()
			last.focus()
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault()
			first.focus()
		}
	}

	showStep(step) {
		this.$el.findElement('step').prop('hidden', true)
		this.$el
			.find(`.${CallbackPopup.title}__step--${step}`)
			.prop('hidden', false)
	}

	setError(message) {
		this.error.text(message)
	}

	setLoading(loading) {
		this.submitButton.prop('disabled', loading)
		this.$el.findElement('submit-text').prop('hidden', loading)
		this.$el.findElement('loading').prop('hidden', !loading)
	}
}
